import Photo from '@blocks/Photo'
import { useSalonContext } from '@customer/components/pages/Salon/context'
import PhotoSlider from '@customer/components/sliders/Photo'
import useSlider from '@hooks/useSlider'
import { ReactComponent as EditIcon } from '@icons/edit.svg'
import React from 'react'

export default function SalonVotingParticipation({ participation }: Props) {
    const { salon, gallery } = useSalonContext()

    const handleChange = (photo: Interfaces.Photo) => {
        gallery.methods.update(photo)
        salon.methods.photo.update(photo)
    }

    const slider = useSlider(PhotoSlider, {
        photo: participation.photo,
        onChange: handleChange
    })

    return <Photo data={participation.photo} onClick={slider.open} toolbar={[
        { icon: <EditIcon />, onClick: slider.open }
    ]} />
}

interface Props {
    participation: Customer.Resources.Participation
}